import * as Yup from "yup";

export const DebitCreditAddFormValidation = Yup.object({
  amount: Yup.number()
    .nullable()
    .typeError("عدد وارد نمایید")
    .positive("عدد وارد نمایید")
    .integer(),

  type: Yup.string().required("نوع را انتخاب نمایید"),
});
